<template>
  <v-app>
    <v-navigation-drawer
       app
      v-model="drawer"
      hide-overlay

    >
    <v-list v-if="$store.getters.user.loggedIn">
       <v-list-item>
         <v-list-item-avatar  v-if="$store.getters.user.data.picture !== null">
           <v-img :src="$store.getters.user.data.picture"></v-img>
         </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="title">  Score: {{  $store.getters.user.data.score }}  </v-list-item-subtitle>
            <v-list-item-subtitle>{{  Object.keys($store.getters.user.data.validations).length }} validation(s)</v-list-item-subtitle>
          </v-list-item-content>
       </v-list-item>
       <v-list-item link>
         <v-list-item-content>
           <v-list-item-title class="title">  {{  $store.getters.user.data.displayName}} </v-list-item-title>
           <v-list-item-subtitle>{{ $store.getters.user.data.email }}</v-list-item-subtitle>
         </v-list-item-content>

         <v-list-item-action>
           <v-icon>mdi-menu-down</v-icon>
         </v-list-item-action>
       </v-list-item>
     </v-list>
     <v-divider></v-divider>
      <v-list nav dense
       >
       <v-list-item link :to="{name: 'Home'}">
         <v-list-item-action>
           <v-icon color="teal darken-2">mdi-home</v-icon>
         </v-list-item-action>
         <v-list-item-content>
           <v-list-item-title class="text-capitalize">{{ $t("menu.home") }}</v-list-item-title>
         </v-list-item-content>
       </v-list-item>
        <v-list-item link :to="{name: 'Points'}">
          <v-list-item-action>
            <v-icon color="teal darken-2">mdi-map-marker</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">{{ $t("menu.points") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item  link :to="{name: 'Rankings'}">
          <v-list-item-action>
            <v-icon color="teal darken-2">mdi-star</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">{{ $t("menu.ranking") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$store.getters.user.loggedIn" link :to="{name:'Validations'}" >
                <v-list-item-action>
                  <v-icon color="teal darken-2">mdi-check</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="text-capitalize">{{ $t("menu.validations") }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
        <v-list-item v-if="$store.getters.user.loggedIn" link @click="logout">
                <v-list-item-action>
                  <v-icon color="teal darken-2">mdi-logout</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title class="text-capitalize">{{ $t("menu.logout") }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!$store.getters.user.loggedIn" link :to="{name:'Signin'}">
                      <v-list-item-action>
                        <v-icon color="teal darken-2">mdi-login</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title class="text-capitalize">{{ $t("menu.signin") }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="!$store.getters.user.loggedIn" link :to="{name:'Signup'}">
                            <v-list-item-action>
                              <v-icon color="teal darken-2">mdi-account-plus</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title class="text-capitalize">{{ $t("menu.signup") }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item link :to="{name: 'Settings'}">
                            <v-list-item-action>
                              <v-icon color="teal darken-2">mdi-cogs</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title class="text-capitalize">{{ $t("menu.settings") }}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
        <v-list-item link :to="{name: 'Legals'}">
          <v-list-item-action>
            <v-icon color="teal darken-2">mdi-information</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">{{ $t("menu.legals") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider/>

        <v-list-item>{{ $store.getters.appVersion }}</v-list-item>
      </v-list>
      <v-list nav dense v-if="$store.getters.roles.includes('admin')">
        <v-list-item link v-if="$store.getters.roles.includes('admin')">
            <v-list-item-content>
                <v-list-item-title class="text-capitalize">Admin</v-list-item-title>
            </v-list-item-content>

        </v-list-item>
        <v-list-item link :to="{name: 'AdminPointList'}">
          <v-list-item-action>
            <v-icon color="teal darken-2">mdi-map-marker</v-icon>
          </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title class="text-capitalize">Points d'intérêts</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{name: 'AdminPointList'}">
              <v-list-item-action><v-icon color="teal darken-2">mdi-check</v-icon>  </v-list-item-action>
            <v-list-item-content>
            <v-list-item-title class="text-capitalize">Validations</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div v-if="drawer" class="custom_overlay" @click="drawer = !drawer"></div>

<!--    <v-app-bar
      app
      color="teal darken-2"
      dark
      class="elevation-10"
    >
    <v-app-bar-nav-icon aria-label="menu" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-0"
          contain
          src="img/gofrance_solo_o.png"
          transition="scale-transition"
          width="50"
        />
      <span class="font-weight-black text-capitalize baloo-text" style="font-size: x-large"><v-badge inline content="beta" color="error">
Go-France</v-badge></span>

      </div>

      <v-spacer></v-spacer>
<v-btn v-if="$store.getters.filterIcon" @click="$store.dispatch('openFilterPointsDrawer')" icon><v-icon>mdi-filter</v-icon></v-btn>

</v-app-bar>-->
<Nav :toggleDrawer="toggleDrawer"/>

    <v-content>
    <router-view></router-view>
    </v-content>

    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="$store.state.d">
    <!-- key is used to refresh -->
    <Detail :key="$store.state.dialog.refresh"  :modal="true" :id="$store.state.dialog.id" :data="$store.state.dialog.data" />
  </v-dialog><v-snackbar color="teal darken-2" :vertical="true" :timeout="8000" v-model="$store.state.snackSignup">{{ $t('main.snackSignup')}}</v-snackbar>
  </v-app>
</template>
<style>
.baloo-text {
  font-family: 'Baloo 2', cursive;
}
.gofrance-text {
  color: #00796b;
}
.custom_overlay {
  position: fixed;
  height: 100vh;
  width: 100%;
  background: rgba(50,50,50,0.5);
    z-index:2;
}
</style>
<script>
import Detail from '@/components/points/detail.vue';
import firebase from '@firebase/app';
export default {
  name: 'App',
  components: { Nav: () => import(/* webpackChunkName: "navbar", webpackPrefetch: 0, webpackPreload: true */"./components/navbar"), Detail },


  data: () => ({
    drawer: false
  }),
  methods: {
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
    logout() {
      firebase.auth().signOut().then(() => {
        this.$store.dispatch('setRoles', []);
        this.$router.push({name:'Home'});
      });
    }
  },
  mounted() {
    document.getElementById('temp_header').style.display = 'none';
  }
};
</script>
